import { PermissionCode } from "../response-models/role";

export interface Navbar {
    name: string;
    icon: any;
    routerLink?: string;
    headerColor?: string;
    navIconColor?: string;
    subCategory: Navbar[];
    permissionCodes: PermissionCode[];
    hidden?: boolean;
    disabled?: boolean;
    organisationSetting?: string;
}

export enum NavbarStatus{
    OPEN,
    MINIMISED,
    MOBILE
}
